/**
 * Created by Daniela on 23/01/2017.
 */
import { NgModule } from '@angular/core';

import { TipoAjustesComponent } from './tipo-ajustes.component';
import { SharedModule } from "../../shared/shared.module";
import { TipoAjusteApiService } from "./shared/tipo-ajuste-api.service";
import { TipoAjusteNavigationService } from "./shared/tipo-ajuste-navigation.service";
import { TipoAjusteService } from "./shared/tipo-ajuste.service";
import { TipoAjustesRoutingModule } from "./tipo-ajustes-routing.module";
import { TipoAjusteFormComponent } from "./tipo-ajuste-form/tipo-ajuste-form.component";
import { TipoAjusteListComponent } from "./tipo-ajuste-list/tipo-ajuste-list.component";

@NgModule({
    imports: [
        SharedModule,
        TipoAjustesRoutingModule
    ],
    providers: [
        TipoAjusteApiService,
        TipoAjusteNavigationService,
        TipoAjusteService
    ],
    declarations: [
        TipoAjustesComponent,
        TipoAjusteFormComponent,
        TipoAjusteListComponent
    ]
})
export class TipoAjustesModule { }



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/abastecimentos/tipo-ajustes/tipo-ajustes.module.ts
 **/